export var buildEnv = {
    // @ts-ignore replaced at build time
    systemClock: 'false' === 'true',
};
//# sourceMappingURL=buildEnv.js.map